export default {
    billType: [ // 单据类型，和后端InventoryBillType对应
        {name: "采购入库", type: 1, style: "success"},
        {name: "采购退货", type: 50, style: "success"},
        {name: "销售出库", type: 101, style: "primary"},
        {name: "销售退货", type: 150, style: "primary"},
        {name: "盘点报溢", type: 201, style: "warning"},
        {name: "盘点报损", type: 250, style: "warning"},
        {name: "组装入库", type: 301, style: "danger"},
        {name: "组装出库", type: 350, style: "danger"},
        {name: "调拨入库", type: 401, style: "info"},
        {name: "调拨出库", type: 450, style: "info"},
        {name: "其它入库", type: 901, style: "info"},
        {name: "其它出库", type: 950, style: "info"},
    ],
    getBillTypeTag(type) {
        for (let i = 0; i < this.billType.length; i++) {
            if (this.billType[i].type === type) {
                return this.billType[i].style;
            }
        }
        return "";
    },
    getBillTypeName(type) {
        for (let i = 0; i < this.billType.length; i++) {
            if (this.billType[i].type === type) {
                return this.billType[i].name;
            }
        }
        return "";
    }
}